import { render, staticRenderFns } from "./App.vue?vue&type=template&id=398e7b1f&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Proyects\\Happybox\\happyboxstore-repo\\normal-curated\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('398e7b1f')) {
      api.createRecord('398e7b1f', component.options)
    } else {
      api.reload('398e7b1f', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=398e7b1f&", function () {
      api.rerender('398e7b1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "NormalCurated/App.vue"
export default component.exports